import React, { useState } from 'react';
import GetDistricts from '../Dropdowns/getDistricts';
import CircularProgress from "@mui/material/CircularProgress";
function FPS_Device_Mapping() {
    const [distCode, setDistCode] = useState('');
    const [details, setDetails] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [search, setSearch] = useState('');
    const [perPage, setPerPage] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [showAll, setShowAll] = useState(false);
    const [showPrintPreview, setShowPrintPreview] = useState(false);
    const handleDistrictChange = (dist_code) => {
        console.log('District changed to:', dist_code);
        setDistCode(dist_code);
        setError(''); 
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Selected dist_code before submit:', distCode);
        if (!distCode || distCode === '') {
            alert("Please Select District");
            return;
        }
        setLoading(true);
        setError('');
        try {
            const response = await fetch(`${process.env.REACT_APP_URL_FPS}/api/fpsdevicemapping/device`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `dist_code=${distCode}`,
            });
            const data = await response.json();
            console.log('Response data:', data);
            if (response.ok) {
                setDetails(data);
                setCurrentPage(1);
                setSearch('');
                setShowAll(false);
            } else {
                setDetails(null);
                setError('Invalid Exception');
            }
        } catch (error) {
            console.error('Error fetching details:', error);
            setDetails(null);
            setError('Invalid Exception');
        } finally {
            setLoading(false);
        }
    };
    const goBack = () => {
        window.history.back();
    };
    const normalize = (value) => {
        if (value == null) return "";
        const num = Number(value);
        return isNaN(num) ? String(value).toLowerCase() : String(num);
    };
    const filteredList = details?.list.filter(item => {
        const searchText = normalize(search);
        const itemValues = [
            item.fps_id,
            item.terminal_id,
            item.del_name,
            item.nom_1_name,
            item.nom_2_name
        ];
        const itemString = itemValues
            .map(v => normalize(v))
            .join(" ")
            .toLowerCase();
        return itemString.includes(searchText);
    }) || [];
    const totalPages = showAll ? 1 : Math.ceil(filteredList.length / perPage);
    const startIndex = showAll ? 0 : (currentPage - 1) * perPage;
    const endIndex = showAll ? filteredList.length : Math.min(startIndex + perPage, filteredList.length);
    const paginatedList = filteredList.slice(startIndex, endIndex);
    const exportToExcel = (tableID, filename = '') => {
        const table = document.getElementById(tableID);
        const tableClone = table.cloneNode(true);
     
        tableClone.querySelectorAll('td, th').forEach(cell => {
            cell.setAttribute('style', 'mso-number-format:"\\@"; text-align: left;');
        });
     
        tableClone.querySelectorAll('thead tr').forEach(row => {
            row.querySelectorAll('th').forEach(th => {
                th.setAttribute('style', 'background-color: black; color: white; font-weight: bold; text-align: left; mso-number-format:"\\@";');
            });
        });
     
        const tableHTML = tableClone.outerHTML.replace(/(\r\n|\n|\r)/gm, '');
        filename = filename ? filename + '.xls' : 'FPS_Device_Mapping.xls';
        const htmlContent = `
          <html xmlns:o="urn:schemas-microsoft-com:office:office"
                xmlns:x="urn:schemas-microsoft-com:office:excel"
                xmlns="http://www.w3.org/TR/REC-html40">
          <head>
              <meta charset="UTF-8">
              <!--[if gte mso 9]>
              <xml>
                  <x:ExcelWorkbook>
                      <x:ExcelWorksheets>
                          <x:ExcelWorksheet>
                              <x:Name>FPS Device Mapping</x:Name>
                              <x:WorksheetOptions>
                                  <x:Print>
                                      <x:ValidPrinterInfo/>
                                  </x:Print>
                              </x:WorksheetOptions>
                          </x:ExcelWorksheet>
                      </x:ExcelWorksheets>
                  </x:ExcelWorkbook>
              </xml>
              <![endif]-->
          </head>
          <body>
              ${tableHTML}
          </body>
          </html>`;
     
        const blob = new Blob([htmlContent], {
            type: 'application/vnd.ms-excel;charset=utf-8;',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const printPreview = () => {
        if (!details || !details.list || details.list.length === 0) {
            alert("No data available to print.");
            return;
        }
        setSearch('');
        setShowAll(true);
        setCurrentPage(1);
        setShowPrintPreview(true);
    };
    const printButtonStyle = {
        background: "#3c4fbdff",
        color: "white",
        textDecoration: "underline",
        marginLeft: "30px",
        border: "none",
        padding: "4px 12px",
        borderRadius: "4px",
        cursor: "pointer"
    };
    const pageBtn = {
        background: "#3c4fbdff",
        color: "white",
        textDecoration: "underline",
        marginRight: "5px",
        padding: "2px 7px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer"
    };
    if (showPrintPreview && details) {
        return (
            <div align="center" style={{ minHeight: "100vh" }}>
                <style>{`
                    @media print {
                        body * { visibility: hidden; }
                        #print-content, #print-content * { visibility: visible; }
                        #print-content { position: absolute; left: 0; top: 0; width: 100%; }
                        .top-button { display: none !important; }
                        .print-buttons { display: none !important; }
                    }
                `}</style>
                <div id="print-content">
                    <div id="detailsR" style={{ marginTop: "15px" }}>
                        <table width="90%" id="Report" border="1">
                            <thead style={{ position: "sticky", top: 0 }}>
                              
                                <tr className="tableheader">
                                    <th colSpan={6}>
                                        FPS Dealer & Device Details for {details.dist_name_en}
                                    </th>
                                </tr>
                                <tr className="tableheader">
                                    <th style={{ textAlign: "left" }}>Shop No</th>
                                    <th style={{ textAlign: "left" }}>FPS</th>
                                    <th style={{ textAlign: "left" }}>Terminal Id</th>
                                    <th style={{ textAlign: "left" }}>Dealer<br /> Name</th>
                                    <th style={{ textAlign: "left" }}>Nominee I<br /> Name</th>
                                    <th style={{ textAlign: "left" }}>Nominee II<br /> Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {details.list.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: "left" }}>{index + 1}</td>
                                        <td style={{ textAlign: "left" }}>{item.fps_id}</td>
                                        <td style={{ textAlign: "left" }}>{item.terminal_id}</td>
                                        <td style={{ textAlign: "left" }}>{item.del_name}</td>
                                        <td style={{ textAlign: "left" }}>{item.nom_1_name}</td>
                                        <td style={{ textAlign: "left" }}>{item.nom_2_name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="print-buttons" style={{ width: "90%", marginTop: "10px", textAlign: "center" }}>
                            <button className="button button2" onClick={() => window.print()} style={{ marginRight: "7px" }}>
                                Print
                            </button>
                            <button className="button button2" onClick={() => {
                                setShowPrintPreview(false);
                                setShowAll(false);
                            }}>
                                Close
                            </button>
                        </div>
                        <br /><br />
                    </div>
                </div>
                <button
                    className="top-button"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    style={{
                        position: "fixed",
                        right: "18px",
                        bottom: "18px",
                        zIndex: 9999,
                        backgroundColor: "#f1872bff",
                        color: "#100d0dff",
                        border: "none",
                        padding: "12px 14px",
                        borderRadius: "20px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        cursor: "pointer"
                    }}
                    title="Go to Top"
                >
                    Top
                </button>
                <br /><br /><br /><br />
            </div>
        );
    }
    return (
        <div>
         
            <table width="30%" align="center" style={{ marginBottom: "15px", marginTop: "15px" }}>
                <tbody>
                    <tr>
                        <td colSpan="2" className="tableheader">FPS Details</td>
                    </tr>
                    <tr>
                        <td>District</td>
                        <td>
                            <GetDistricts
                                onLoadingChange={setLoadingDistricts}
                                onChange={handleDistrictChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2" align="center">
                            <button onClick={handleSubmit} className="button button2" style={{ marginRight: "7px" }}>Submit</button>
                            <button onClick={goBack} className="button button2">Back</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            {loading && (
                <div align="center" id="loading" style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <CircularProgress />
                </div>
            )}
            <br />
            {error && (
                <div align="center">
                    <span className="response" style={{ color: "red", fontWeight: "bold" }}>{error}</span>
                </div>
            )}
            {details && details.list_size > 0 && !loading && !showPrintPreview && (
                <>
                  
                    <div style={{ width: "90%", margin: "0 auto", textAlign: "center" }}>
                       
                        <div className="response" style={{ fontWeight: "bold", fontSize: "20px", marginBottom: "30px" }}>
                            FPS Dealer & Device Details for <u>{details.dist_name_en}</u>
                        </div>
                      
                        <div style={{ position: "relative", width: "100%", marginBottom: "20px" }}>
                            <div style={{ textAlign: "center" }}>
                                <span>per page </span>
                                <select
                                    value={showAll ? "All" : perPage}
                                    onChange={(e) => {
                                        if (e.target.value === "All") {
                                            setShowAll(true);
                                        } else {
                                            setShowAll(false);
                                            setPerPage(Number(e.target.value));
                                        }
                                        setCurrentPage(1);
                                    }}
                                    style={{ margin: "0 5px" }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value="All">All</option>
                                </select>
                                <button onClick={printPreview} style={printButtonStyle}>
                                    Print
                                </button>
                            </div>
                         
                            <div style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}>
                                <span style={{ marginRight: "5px" }}>Search</span>
                                <input
                                    type="text"
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    style={{ paddingRight: "25px" }}
                                />
                                {search && (
                                    <span
                                        onClick={() => {
                                            setSearch("");
                                            setCurrentPage(1);
                                        }}
                                        style={{
                                            position: "absolute",
                                            right: 6,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                            fontSize: "12px",
                                            userSelect: "none",
                                        }}
                                        title="Clear Search"
                                    >
                                        ✖
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                 
                    <div id="detailsR" style={{ width: "80%", margin: "0 auto" }}>
                        <table id="Report" style={{ width: "100%", marginLeft: 0, border: "1" }}>
                            <thead style={{ position: "sticky", top: 0 }}>
                                <tr className="tableheader">
                                    <th style={{ textAlign: "left" }}>Shop No</th>
                                    <th style={{ textAlign: "left" }}>FPS</th>
                                    <th style={{ textAlign: "left" }}>Terminal Id</th>
                                    <th style={{ textAlign: "left" }}>Dealer<br /> Name</th>
                                    <th style={{ textAlign: "left" }}>Nominee I<br /> Name</th>
                                    <th style={{ textAlign: "left" }}>Nominee II<br /> Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedList.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: "left" }}>{startIndex + index + 1}</td>
                                        <td style={{ textAlign: "left" }}>{item.fps_id}</td>
                                        <td style={{ textAlign: "left" }}>{item.terminal_id}</td>
                                        <td style={{ textAlign: "left" }}>{item.del_name}</td>
                                        <td style={{ textAlign: "left" }}>{item.nom_1_name}</td>
                                        <td style={{ textAlign: "left" }}>{item.nom_2_name}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                     
                        <div style={{ width: "100%", marginTop: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0", marginLeft: 0 }}>
                            <div style={{ color: "#792020ff", fontWeight: "bold", textAlign: "left", flex: 1 }}>
                                Showing {filteredList.length > 0 ? startIndex + 1 : 0} to {endIndex} of {filteredList.length} entries
                            </div>
                            {!showAll && (
                                <div style={{ textAlign: "right", flex: 1, whiteSpace: "nowrap" }}>
                                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} style={pageBtn}>
                                        First
                                    </button>
                                    <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={pageBtn}>
                                        Previous
                                    </button>
                                    {[...Array(totalPages)].map((_, i) => {
                                        if (i === 0 || i === totalPages - 1 || (i >= currentPage - 2 && i <= currentPage + 1)) {
                                            return (
                                                <button
                                                    key={i}
                                                    onClick={() => setCurrentPage(i + 1)}
                                                    style={{ ...pageBtn, background: currentPage === i + 1 ? "black" : "#3c4fbdff" }}
                                                >
                                                    {i + 1}
                                                </button>
                                            );
                                        } else if (i === currentPage - 3 || i === currentPage + 2) {
                                            return <span key={i} style={{ marginRight: "5px" }}>...</span>;
                                        }
                                        return null;
                                    })}
                                    <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={pageBtn}>
                                        Next
                                    </button>
                                    <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} style={pageBtn}>
                                        Last
                                    </button>
                                </div>
                            )}
                        </div>
                     
                        <div style={{ width: "100%", marginTop: "10px", textAlign: "center", marginLeft: 0 }}>
                            <button
                                className="button button2"
                                onClick={() => exportToExcel('Report', 'FPS_Device_Mapping_Details')}
                                style={{ marginTop: '10px' }}
                            >
                                Data To Excel
                            </button>
                        </div>
                        <br /><br />
                    </div>
                </>
            )}
            {details && details.list_size === 0 && (
                <div align="center">
                    <div className="response">FPS Details Not Found</div>
                </div>
            )}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                style={{
                    position: "fixed",
                    right: "18px",
                    bottom: "18px",
                    zIndex: 9999,
                    backgroundColor: "#f1872bff",
                    color: "#100d0dff",
                    border: "none",
                    padding: "12px 14px",
                    borderRadius: "20px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    cursor: "pointer"
                }}
                title="Go to Top"
            >
                Top
            </button>
            <br /><br /><br /><br />
        </div>
    );
}
export default FPS_Device_Mapping;